import React from 'react';
import MusicAlbumReleaseStepsView from './MusicAlbumReleaseStepsView';
import MusicAlbumEditForm1ViewArtistInput from './MusicAlbumEditForm1ViewArtistInput';
import MusicAlbumEditForm1ViewTitleInput from './MusicAlbumEditForm1ViewTitleInput';
import MusicAlbumCorrectionRequestView from './MusicAlbumCorrectionRequestView';
import CustomButton from '../../../common/components/CustomButton';
import CustomSelect from '../../../common/components/CustomSelect';
import CustomUpload from '../../../common/components/CustomUpload';
import { MusicAlbumEntity, MusicAlbumTrackEntity } from '../../types/MusicAlbumEntityTypes';
import { MusicEntity } from '../../types/MusicEntityTypes';
import { FieldValidationErrorsType } from '../../../common/form/FrekulForm';

type MusicAlbumEditForm1ViewFieldName =
  'title'|'title_kana'|'title_en'|'is_multiple'|'genre'|'image_delete'|
  ['music_album_artists', number, 'name'|'name_kana'|'name_en'];
type MusicAlbumEditForm1ViewFileName = 'image';

export default function MusicAlbumEditForm1View({
  getFile,
  setFile,
  deleteFile,
  getValue,
  setValue,
  getErrors,
  getNumberOfItems,
  addItem,
  musicAlbum,
  genreOptions,
  onNext,
  onBack,
  onStep,
} : {
  getFile: (name: MusicAlbumEditForm1ViewFileName) => FileList|null,
  setFile: (name: MusicAlbumEditForm1ViewFileName, file: FileList) => void,
  deleteFile: (name: MusicAlbumEditForm1ViewFileName) => void,
  getValue: (name: MusicAlbumEditForm1ViewFieldName) => string,
  setValue: (name: MusicAlbumEditForm1ViewFieldName, value: string) => void,
  getErrors: (name: MusicAlbumEditForm1ViewFieldName|MusicAlbumEditForm1ViewFileName) => FieldValidationErrorsType,
  getNumberOfItems: (name: 'music_album_artists') => number,
  addItem: (name: 'music_album_artists') => void,
  musicAlbum: MusicAlbumEntity & {
    music_album_tracks: (MusicAlbumTrackEntity & {
      music: MusicEntity,
    })[],
  },
  genreOptions: {
    value: string,
    text: string,
  }[],
  onBack: () => void,
  onNext: () => void,
  onStep: (callback: (musicAlbumId: number) => void) => void,
}) {

  return (
    <>
      <MusicAlbumReleaseStepsView
        step={1}
        musicAlbum={musicAlbum}
        onClick={(callback) => onStep(callback)}
      />
      <MusicAlbumCorrectionRequestView musicAlbum={musicAlbum} />
      <form className="music_list" id="edit_album">
        <div className="form__body">
          <MusicAlbumEditForm1ViewTitleInput
            getValue={getValue}
            setValue={setValue}
            getErrors={getErrors}
          />
          <MusicAlbumEditForm1ViewArtistInput
            getNumberOfItems={getNumberOfItems}
            addItem={addItem}
            setValue={setValue}
            getValue={getValue}
            getErrors={getErrors}
          />
          <dl>
            <dt>
              { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
              <label htmlFor="confirmation items">ジャンル</label>
            </dt>
            <dd>
              <CustomSelect
                value={getValue('genre')}
                setValue={(value) => setValue('genre', value)}
                // eslint-disable-next-line max-len
                options={genreOptions.map((option) => ({ title: option.text, value: option.value }))}
                validationErrors={getErrors('genre')}
              />
              <p className="text_info_on">
                半分以上が歌なしの曲の場合「インストゥルメンタル」を設定してください。
              </p>
            </dd>
          </dl>
          <dl>
            <dt>
              { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
              <label htmlFor="upload">ジャケット画像</label>
            </dt>
            <dd>
              <p className="text_info_on">
                推奨サイズ：1400px~3000pxの正方形画像,カラーモード:RGB
              </p>
              <CustomUpload
                type="image"
                description="jpg,png(20MBまで)"
                defaultPreviewImage={musicAlbum.image_url}
                files={getFile('image')}
                uploaded={!!musicAlbum.image_url}
                deleted={getValue('image_delete') !== '0'}
                onSelectFiles={(files) => setFile('image', files)}
                onDeleteFiles={() => deleteFile('image')}
                validationErrors={getErrors('image')}
              />
            </dd>
          </dl>
          <p className="top_line" />
          <ul>
            <li className="bt">
              <CustomButton type="cancel-split" onClick={() => onBack()}>戻る</CustomButton>
              <CustomButton type="default-split" onClick={() => onNext()}>保存して次へ</CustomButton>
            </li>
          </ul>
        </div>
      </form>
    </>
  );
}

